jQuery(document).ready(function($){

  if($('.o-tabber')[0]){
    const $posts_wrapper = $('.o-tabber .m-posts');

    $posts_wrapper.each(function(index){
      const $posts = $(this).find('.m-posts__items');
      const $loadMore = $(this).find('.m-posts__button');

      if($posts && $posts.length > 1){
        $posts.slice(0, 1).show();
        $posts.slice(1).hide();
      }

      $loadMore.click(function(){
        const $hiddenPosts = $(this).closest('.m-posts').find('.m-posts__items:hidden');

      
        if($hiddenPosts.length >= 1){
          $hiddenPosts.slice(0, 1).slideDown();
        }

        if($hiddenPosts.length - 1 <= 0){
          $loadMore.hide();
        }

      });
      
    });
  }
});